import { defineComponent as _defineComponent } from 'vue'
import { toRef, onMounted, Ref, ref, onUpdated } from "vue";
import { IMformatDate } from "@/uitls/uitls"
import { msg_get_user_info } from "@/network/socket/SocketReq";
import { getImUser, updateIMList, getImfriendItem } from "@/network/db/dbServe";
import { imMessageListModel, imUserModel } from "@/model/chatModel";
import EventBus from "@/uitls/EventBus";
import { useI18n } from 'vue-i18n'
interface dataProps {
  data: any;
}

export default /*#__PURE__*/_defineComponent({
  name: 'MessageItem',
  props: {
    data: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  data: any;
}

const { t } = useI18n();

const zhubo = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)
const guanliyuan = require(`@/assets/${process.env.VUE_APP_NAME}/admintype.png`)



const data: Ref<imMessageListModel> = toRef(props, "data");

const cellUser = ref();
//是否在线
const online = ref(false);

onMounted(() => {
  //去查这个人的信息
  // if (data.value.uid) {
  //   msg_get_user_info(data.value.uid);
  // }
  // getUser()
  if (!data.value.isGroup) {
    getUser();
  }
})
onUpdated(() => {
  if (!data.value.isGroup) {
    setTimeout(() => {
      // getUser()
    }, 2000)

  }
  EventBus.off("updateGroup")
})
// updateGroup

EventBus.on("updateGroup", (obj: any) => {
  // chatkey: val.chatkey,
  //     url: val.headurl,
  //         name: val.nickname

  if (obj.chatkey == data.value.chatkey) {
    data.value.headurl = obj.url,
      data.value.nickname = obj.name
  }
});

const getUser = async () => {
  
  if (data.value.isGroup) {
    return;
  }
  const user: imUserModel = await getImUser(data.value.uid);
  if (user) {
    if (user.headurl !== data.value.headurl) {
      data.value.headurl = user.headurl
      updateIMList(data.value.chatkey, data.value)
    }
    if (user.lastlogouttime == 0) {
      online.value = true
    }
    cellUser.value = user;
  } else {
    msg_get_user_info(data.value.uid);
  }
}


const msgtypecontent = (data) => {
  const types = data.msgtype;
  switch (types) {
    case 2:
      return t('im.sound');
    case 3:
      return t('im.video');
    case 4:
      return t('im.image');
    case 5:
      return t('im.redpot');
    case 6:
      return t('im.link');
    case 7:
      return t('im.card');
    case 8:
      return t('im.getredpot');
    case 9:
      return t('im.getreadysound');
    case 10:
      return t('im.transfer');
    case 11:
      return t('im.groupcard');
    case 12:
      return t('im.recall');
    case 13:
      return t('im.checkorder');
    // case 14:
    //   return "[server模拟发送信息类型]";
    case 15:
      return t('im.file');
    case 16:
      try {
        const sen = JSON.parse(data.content);
        const msg = sen.content ? sen.content : "[@]";
        return msg;
      } catch (e) {
        console.log('e', data.content);
        const sen = data.content;
        const msg = sen.content ? sen.content : "[@]";
        return msg;
      }
    case 17:
      return t('im.zfhxx');
    case 18:
      return t('im.pay');
    case 19:
      return t('im.ad');
    case 21:
      try {
        const sen = JSON.parse(data.content);
        const msg = sen.content ? sen.content : "";
        return msg;
      } catch (e) {
        console.log('e', data.content);
        const sen = data.content;
        const msg = sen.content ? sen.content : "";
        return msg;
      }
    case 102:
      return t('im.talkover');
    case 10000:
      return t('im.tips');
    case 10001:
      return t('im.grouptips');
    case 10002:
      return t('im.groupconfirm');
    case 10003:
      return t('im.notyoufriend');
    case 10011:
      return t('im.linknotyoufriend');
    case 333:
      return t('im.ad');
    case 334:
      return t('im.groupsend');
    default:
      return data.content;
  }
};

const setHostIcon = (userParamer) => {
  let user:any = userParamer;
  
  if (user.usertype == 1) {
    return zhubo;
  } else if (user.usertype == 2) {
    return guanliyuan;
  } else {
    return "";
  }
}



const __returned__ = { t, zhubo, guanliyuan, props, data, cellUser, online, getUser, msgtypecontent, setHostIcon, IMformatDate }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})